module.exports = __webpack_public_path__ + "img/2.2c99f756.jpg";